module.exports = __webpack_public_path__ + "static/img/DSC_0677.89346c1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DSC_0677.jpeg
// module id = 308
// module chunks = 2